// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.customers__cont .job-id__number {\n  margin: 0 5px;\n  padding: 10px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.customers__cont .job-id__number:hover {\n  background-color: var(--color-primary-hover);\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
